const typography = {
  displayLarge: {
    fontWeight: 500,
    fontSize: 96,
    lineHeight: '112px',
    letterSpacing: '0px',
  },
  displayMedium: {
    fontWeight: 500,
    fontSize: 52,
    lineHeight: '64px',
    letterSpacing: '0px',
  },
  displaySmall: {
    fontWeight: 500,
    fontSize: 44,
    lineHeight: '52px',
    letterSpacing: '0px',
  },
  displayXSmall: {
    fontWeight: 500,
    fontSize: 36,
    lineHeight: '44px',
    letterSpacing: '0px',
  },
  headingXXLarge: {
    fontWeight: 500,
    fontSize: 40,
    lineHeight: '52px',
    letterSpacing: '0px',
  },
  headingXLarge: {
    fontWeight: 500,
    fontSize: 36,
    lineHeight: '44px',
    letterSpacing: '0px',
  },
  headingLarge: {
    fontWeight: 500,
    fontSize: 32,
    lineHeight: '40px',
    letterSpacing: '0px',
  },
  headingMedium: {
    fontWeight: 500,
    fontSize: 28,
    lineHeight: '36px',
    letterSpacing: '0px',
  },
  headingSmall: {
    fontWeight: 500,
    fontSize: 24,
    lineHeight: '32px',
    letterSpacing: '0px',
  },
  headingXSmall: {
    fontWeight: 500,
    fontSize: 20,
    lineHeight: '28px',
    letterSpacing: '0px',
  },
  labelLarge: {
    fontWeight: 500,
    fontSize: 18,
    lineHeight: '24px',
    letterSpacing: '0px',
  },
  labelMedium: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '20px',
    letterSpacing: '0px',
  },
  labelSmall: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '16px',
    letterSpacing: '0px',
  },
  labelXSmall: {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '16px',
    letterSpacing: '0px',
  },
  paragraphLarge: {
    fontWeight: 400,
    fontSize: 18,
    lineHeight: '28px',
    letterSpacing: '0px',
  },
  paragraphMedium: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0px',
  },
  paragraphSmall: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0px',
  },
  paragraphXSmall: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '20px',
    letterSpacing: '0',
  },
  monoDisplayLarge: {
    fontWeight: 500,
    fontSize: 96,
    lineHeight: '112px',
    letterSpacing: '0px',
  },
  monoDisplayMedium: {
    fontWeight: 500,
    fontSize: 52,
    lineHeight: '64px',
    letterSpacing: '0px',
  },
  monoDisplaySmall: {
    fontWeight: 500,
    fontSize: 44,
    lineHeight: '52px',
    letterSpacing: '0px',
  },
  monoDisplayXSmall: {
    fontWeight: 500,
    fontSize: 36,
    lineHeight: '44px',
    letterSpacing: '0px',
  },
  monoHeadingXXLarge: {
    fontWeight: 500,
    fontSize: 40,
    lineHeight: '52px',
    letterSpacing: '0px',
  },
  monoHeadingXLarge: {
    fontWeight: 500,
    fontSize: 36,
    lineHeight: '44px',
    letterSpacing: '0px',
  },
  monoHeadingLarge: {
    fontWeight: 500,
    fontSize: 32,
    lineHeight: '40px',
    letterSpacing: '0px',
  },
  monoHeadingMedium: {
    fontWeight: 500,
    fontSize: 28,
    lineHeight: '36px',
    letterSpacing: '0px',
  },
  monoHeadingSmall: {
    fontWeight: 500,
    fontSize: 24,
    lineHeight: '32px',
    letterSpacing: '0px',
  },
  monoHeadingXSmall: {
    fontWeight: 500,
    fontSize: 20,
    lineHeight: '28px',
    letterSpacing: '0px',
  },
  monoLabelLarge: {
    fontWeight: 500,
    fontSize: 18,
    lineHeight: '24px',
    letterSpacing: '0px',
  },
  monoLabelMedium: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '20px',
    letterSpacing: '0px',
  },
  monoLabelSmall: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '16px',
    letterSpacing: '0px',
  },
  monoLabelXSmall: {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '16px',
    letterSpacing: '0px',
  },
  monoParagraphLarge: {
    fontWeight: 400,
    fontSize: 18,
    lineHeight: '28px',
    letterSpacing: '0px',
  },
  monoParagraphMedium: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0px',
  },
  monoParagraphSmall: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0px',
  },
  monoParagraphXSmall: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '20px',
    letterSpacing: '0px',
  },

  subtitle1Regular: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 'unset',
  },
  subtitle1Medium: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 'unset',
  },
  subtitle1Bold: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 'unset',
  },
  subtitle2Light: {
    fontSize: 14,
    fontWeight: 300,
    lineHeight: 'unset',
  },
  subtitle2Medium: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 'unset',
  },
  subtitle2Bold: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 'unset',
  },
  body2Medium: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 'unset',
  },
  button1: {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 'unset',
  },
  button2: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 'unset',
  },
  button3: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 'unset',
  },
  h5Regular: {
    fontSize: 24,
    fontWeight: 400,
    lineHeight: 'unset',
  },
  h5Medium: {
    fontSize: 24,
    fontWeight: 500,
    lineHeight: 'unset',
  },
  h5Bold: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 'unset',
  },
  h4Regular: {
    fontSize: 34,
    fontWeight: 400,
    lineHeight: 'unset',
  },
  h4Medium: {
    fontSize: 34,
    fontWeight: 500,
    lineHeight: 'unset',
  },
  h4Bold: {
    fontSize: 34,
    fontWeight: 700,
    lineHeight: 'unset',
  },
  h6Regular: {
    fontSize: 24,
    fontWeight: 400,
    lineHeight: 'unset',
  },
  h6Medium: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 'unset',
  },
  h6Bold: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 'unset',
  },

  title1Bold: {
    fontSize: 48,
    fontWeight: 700,
    lineHeight: '62px',
  },
  title1Semibold: {
    fontSize: 48,
    fontWeight: 600,
    lineHeight: '62px',
  },
  title1Regular: {
    fontSize: 48,
    fontWeight: 500,
    lineHeight: '62px',
  },

  title2Bold: {
    fontSize: 32,
    fontWeight: 700,
    lineHeight: '42px',
  },
  title2Semibold: {
    fontSize: 32,
    fontWeight: 600,
    lineHeight: '42px',
  },
  title2Regular: {
    fontSize: 32,
    fontWeight: 500,
    lineHeight: '42px',
  },

  title3Bold: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '31px',
  },
  title3Semibold: {
    fontSize: 24,
    fontWeight: 600,
    lineHeight: '31px',
  },
  title3Regular: {
    fontSize: 24,
    fontWeight: 500,
    lineHeight: '31px',
  },

  body1Bold: {
    fontSize: 18,
    fontWeight: 700,
    lineHeight: '24px',
  },
  body1Semibold: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: '24px',
  },
  body1Regular: {
    fontSize: 18,
    fontWeight: 400,
    lineHeight: '24px',
  },
  body1Light: {
    fontSize: 18,
    fontWeight: 300,
    lineHeight: '24px',
  },

  body2Bold: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '22px',
  },
  body2Semibold: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '22px',
  },
  body2Regular: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '22px',
  },
  body2Light: {
    fontSize: 14,
    fontWeight: 300,
    lineHeight: '22px',
  },

  body3Bold: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '18px',
  },
  body3Semibold: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '18px',
  },
  body3Regular: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '18px',
  },
  body3Light: {
    fontSize: 14,
    fontWeight: 300,
    lineHeight: '18px',
  },

  captionBold: {
    fontSize: 12,
    fontWeight: 700,
    lineHeight: '16px',
  },
  captionSemibold: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
  },
  captionRegular: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
  },
  captionLight: {
    fontSize: 12,
    fontWeight: 300,
    lineHeight: '16px',
  },
} as const;

export type TypographyVariantType = keyof typeof typography;

export default typography;
